// =================================================================
// Engine: CKD-EPI 2021 eGFR (PSD §4.2 / TODO Task 2.5)
// CKD-EPI 2021 (race-free) creatinine equation.
// =================================================================
import { Sex } from '@amino-pk/shared-types';
const KAPPA = 0.7;
const ALPHA_FEMALE = -1.2;
const ALPHA_MALE = -0.302;
const GENDER_COEFF_FEMALE = 1.012;
const BASE = 142;
/**
 * CKD-EPI 2021 eGFR (mL/min/1.73m²) — race-free equation.
 */
export function computeCKDEPI(ageYears, sex, scrMgDl) {
    const isFemale = sex === Sex.Female;
    const k = KAPPA;
    const scrOverK = scrMgDl / k;
    let egfr;
    if (scrMgDl <= k) {
        const alpha = isFemale ? ALPHA_FEMALE : ALPHA_MALE;
        egfr = BASE * Math.pow(Math.min(scrOverK, 1), alpha) * 0.9938 ** ageYears;
    }
    else {
        const alpha = isFemale ? ALPHA_FEMALE : ALPHA_MALE;
        egfr = BASE * Math.pow(Math.min(scrOverK, 1), alpha) * Math.pow(scrOverK, -1.2) * 0.9938 ** ageYears;
    }
    if (isFemale)
        egfr *= GENDER_COEFF_FEMALE;
    return Math.round(egfr * 10) / 10;
}
/**
 * Detect divergence between CrCl and eGFR (PSD §4.2).
 * Divergent when |CrCl − eGFR| / max > 0.30.
 */
export function computeEgfrDiscrepancy(crClMlMin, egfrMlMin173) {
    const max = Math.max(crClMlMin, egfrMlMin173);
    if (max <= 0)
        return { divergent: false };
    const ratio = Math.abs(crClMlMin - egfrMlMin173) / max;
    if (ratio > 0.3) {
        return {
            divergent: true,
            note: `CrCl (${crClMlMin.toFixed(1)}) and CKD-EPI eGFR (${egfrMlMin173.toFixed(1)}) diverge by >30% — interpret with caution.`,
        };
    }
    return { divergent: false };
}
//# sourceMappingURL=ckdEpi.js.map